export default __webpack_public_path__ + "static/media/card-image-6.b62b8a91.jpg";